// extracted by mini-css-extract-plugin
module.exports = {"passportRegion":"style_passportRegion__2ERZq"};